import Chart from 'chart.js/auto';
const chartjs = require('../../../../../../components/chart/chartjs');
const settings = require('../../../../../../js-handler/settings');

let barSimpleChart = null;

export function createChart(parameter) {
	// Asegúrate de que este ID corresponda al canvas real en tu HTML
	const canvas = document.getElementById('chartLineClientActivity');
	const companiesName = document.getElementById('companiesNamePayments');
	const desc = document.querySelector('#page-right-desc-chart-payments');

	if (!canvas) {
		console.log('Canvas chartBarClientActivity no encontrado');
		return;
	}

	if (canvas.clientWidth === 0 || canvas.clientHeight === 0) {
		console.warn("Advertencia: El canvas tiene dimensiones 0.");
	}

	if (companiesName) {
		companiesName.textContent = `${settings.getData().name} and ${settings.getData().company}`;
	}

	if (desc) {
		const param = settings.getData();
		if (param.entity === "clientCustomer") {
			desc.textContent = `
            This shows all the purchases your business "${param.name}" has made from us "${param.company}". 
            The amounts reflect your accounts payable: the money still owed for the goods or services provided to you.
        `;
		} else {
			desc.textContent = `
            This shows all the sales your business "${param.name}" has made to us "${param.company}". 
            The amounts reflect your accounts receivable: the money we owe you for the products or services provided to us.
        `;
		}
	}



	// Destruye el gráfico anterior si existe en el canvas de Chart.js
	const existingChart = Chart.getChart(canvas);
	if (existingChart) {
		existingChart.destroy();
	} else if (barSimpleChart) {
		barSimpleChart.destroy();
		barSimpleChart = null;
	}

	// El query SQL que creamos devuelve la data agrupada dentro de un objeto con la propiedad "data"
	const data = (parameter[0] && parameter[0].data) ? parameter[0].data : [];

	// Generar etiquetas del eje X (Meses)
	const labelsX = data.map(p => {
		const fecha = new Date(p.year_month + '-01T00:00:00');
		return fecha.toLocaleString('default', { month: 'short', year: 'numeric' });
	});

	const isCustomer = settings.getData().entity == 'clientCustomer';

	// Configuramos las dos líneas dependiendo de la perspectiva invertida
	let metricsToGraph = [];

	if (isCustomer) {
		metricsToGraph = [
			{ key: 'customer_net_sales', label: 'To pay', color: 'red' },
			{ key: 'customer_paid', label: 'Paid', color: 'orange' }
		];
	} else {
		metricsToGraph = [
			{ key: 'provider_total_investment', label: 'Sales', color: 'orange' },
			{ key: 'provider_paid', label: 'To received', color: 'red' }
		];
	}

	// Construir el dataset para el gráfico de líneas utilizando la estructura de tu componente chartjs
	const chartData = metricsToGraph.map((m) => {
		return {
			label: m.label,
			color: m.color,
			tension: 0.4,
			borderWidth: 2,
			fill: false,
			value: data.map((periodo, i) => ({
				x: labelsX[i],
				y: parseFloat(periodo[m.key]) || 0
			}))
		};
	});

	// Inicializar el gráfico de líneas múltiples
	barSimpleChart = chartjs.start({
		elem: 'line',
		act: 'createMultiple',
		targetChart: { html: canvas },
		data: chartData,
		options: {
			responsive: true,
			maintainAspectRatio: false,
			aspectRatio: 10 / 4.1,
			legend: true,
			plugins: {
				tooltip: { enabled: true }
			}
		}
	});
}